import Axios from 'axios'
import server from 'util/Server'


export const getListRecaudosGnv = (query: any) => {
  return Axios.get(server?.host! + server?.puertoMsGnv + `/api/v1/recaudos`, { params: query, headers: { Authorization: server.obtenerToken() } })
}

export const importadorRecaudosGnv = async (body: any) => {
  try {
    const response = await Axios.post(server?.host! + server?.puertoMsGnv + `/api/v1/recaudos/importer`, body, { headers: { Authorization: server.obtenerToken() } })
    return response
  } catch (error: any) {
    return error?.response.data || { message: 'Error al importar los datos', error: true, data: null}
  }
}


export const getVehiculoByClientGnv = async (params: any) => {
  return Axios.get(server?.host! + server?.puertoMsGnv + `/api/v1/vehiculos`, { params, headers: { Authorization: server.obtenerToken() } })
}

export const registerRecaudoGnv = async (body: any, id_vehiculo: any, method: 'post' | 'put', id_vehiculo_recaudo: any) => {

  const urlPut = `/api/v1/vehiculos/${id_vehiculo}/recaudos/${id_vehiculo_recaudo}`
  const urlPost = `/api/v1/vehiculos/${id_vehiculo}/recaudos`

  return Axios[method](server?.host! + '8011' + (method == 'post' ? urlPost : urlPut), body, { headers: { Authorization: server.obtenerToken() } })
}
export const getRecaudoByVehiculoGnv = async (id_vehiculo: any) => {
  return Axios.get(server?.host! + server?.puertoMsGnv + `/api/v1/vehiculos/${id_vehiculo}/recaudos`, { headers: { Authorization: server.obtenerToken() } })
}

export const getAllConceptos = async (organizacionId: number) => {
  return Axios.get(server?.host! + '8011' + `/api/v1/conceptos-recaudo?organizacion=${organizacionId}`, { headers: { Authorization: server.obtenerToken() } })
}


export const postCreditosRecaudoVehiculoGnv = async (body: any) => {
  try {
    const { data } = await Axios.post(server?.host! + server?.puertoMsGnv + `/api/v1/vehiculos-creditos`, body, { headers: { Authorization: server.obtenerToken() } })

    return data
  } catch (err: any) {
    return {
      message: err?.response?.data?.message || 'Error al registrar el recaudo',
      error: true,
      data: null
    }
  }
}

export const patchEstadoCreditosRecaudoVehiculoGnv = async (recaudo_id: any, usuario_id: number) => {
  try {
    const { data } = await Axios.patch(server?.host! + server?.puertoMsGnv + `/api/v1/vehiculos-creditos/${recaudo_id}/inactivar?usuario_modificacion_id=${usuario_id}`, {}, { headers: { Authorization: server.obtenerToken() } })

    return data
  } catch (err: any) {
    return {
      message: err?.response?.data?.message || 'Error al inactivar el recaudo',
      error: true,
      data: null
    }
  }
}
export const getReporteGenerealRecaudos = async (parametros: any) => {

  const { vehiculo_id, cliente_id, es_organizacion, organizacion_id, fecha_inicio, fecha_fin, tipo_reporte } = parametros

  try {
    const { data } = await Axios.get(server?.host! + server?.puertoMsGnv + `/api/v1/vehiculos-creditos/reporte-generales`,
      {
        params: { vehiculo_id, cliente_id, es_organizacion, organizacion_id, fecha_inicio, fecha_fin, tipo_reporte },
        headers: { Authorization: server.obtenerToken() }
      })

    return data
  } catch (err: any) {
    return {
      message: err?.response?.data?.message || 'Error al inactivar el recaudo',
      error: true,
      data: null
    }
  }
}

